import { GeneralOverlayItem } from './GeneralOverlayItem'
import { MarkTest } from './MarkTest'
import { MarkLabel } from './MarkLabel'

export const getOverlayItem =
  (isTestMode: boolean): GeneralOverlayItem =>
    isTestMode
      ? MarkTest
      : MarkLabel
